import { inventoryConstants } from "../Constants/inventoryConstant";

const initialValues = {
  isLoading: false,
  items: [],
  item_detailed: {},
  movements: [],
  stock_takes: [],
  stock_take_detailed: {},
  low_stock: [],
  scan_result: null,
  response: {
    state: null,
    message: "",
  },
};

const inventoryReducer = (state = initialValues, action) => {
  switch (action.type) {
    case inventoryConstants.LOADING:
      return { ...state, isLoading: action.isLoading };
    case inventoryConstants.GET_ITEMS:
      return { ...state, items: action.payload.items };
    case inventoryConstants.GET_ITEM_DETAILED:
      return { ...state, item_detailed: action.payload.item };
    case inventoryConstants.GET_MOVEMENTS:
      return { ...state, movements: action.payload.movements };
    case inventoryConstants.GET_STOCK_TAKES:
      return { ...state, stock_takes: action.payload.stock_takes };
    case inventoryConstants.GET_STOCK_TAKE_DETAILED:
      return { ...state, stock_take_detailed: action.payload.stock_take };
    case inventoryConstants.GET_LOW_STOCK:
      return { ...state, low_stock: action.payload.low_stock };
    case inventoryConstants.SCAN_RESULT:
      return { ...state, scan_result: action.payload.scan_result };
    case inventoryConstants.RESPONSE:
      return {
        ...state,
        response: {
          state: action.response.state,
          message: action.response.message,
        },
      };
    default:
      return state;
  }
};

export default inventoryReducer;
